import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowPreviewTemplate } from "themes/application/facility-order-new-flow/pages";
import { FacilityOrderNewFlowPreviewViewStore } from "application/facility-order-new-flow/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowPreviewViewStore(rootStore), "facilityOrderNewFlowPreviewViewStore")
@observer
class FacilityOrderNewFlowPreview extends React.Component {
	render() {
		return <FacilityOrderNewFlowPreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowPreview;